<template>
  <div>
    <headers />
    <div class="content">
      <div class="main">
        <div class="box">
          <div class="login">
            <h3>登录{{seotitle.seo_title}}</h3>
            <div class="item">
              <i class="uname"></i>
              <input type="text" name="uname" placeholder="请输入登录手机号" v-model="value" />
            </div>
            <div class="item">
              <i class="pwd"></i>
              <input type="password" name="uname" placeholder="请输入登录密码" v-model="sms" />
            </div>
            <router-link tag="div" to="/retrieves" class="item zhmm">
              <em>忘记密码？</em>
            </router-link>
            <input type="button" class="btn" value="登录" @click="sigin" />
          </div>
          <div class="notice">
            没有账号？
            <router-link tag="a" to="/register">立即注册</router-link>
          </div>
        </div>
      </div>
    </div>
    <footers />
    <!-- <div style="height:140px;"></div>
    <div class="baofooter">
      
    </div> -->
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { Message } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    headers,
    footers,
    [Message.name]: Message
  },
  data() {
    return {
      value: null,
      sms: null,
      seotitle:{},
    };
  },
  methods: {
    sigin() {
      var data = utilFile.encrypt(
        JSON.stringify({
          phone: this.value,
          pwd: this.sms
        })
      );
      this.$axios({
        method: "post",
        url: `/api/authority.login?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          localStorage.setItem("mobile", this.value); //缓存帐号 设置支付密码使用 //yong
          setTimeout(() => {
            this.$router.push({
              path:"/index"
            })
          }, 1000);
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    titlefunc() {
      this.$axios({
        method: "post",
        url: `/api/home.config`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let data = JSON.parse(utilFile.decrypt(res.data.data));
        this.seotitle = data;
      });
    },
  },
  mounted(){
    this.titlefunc();
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 620px;
  background-image: url("~@/assets/images/login_bg.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% 100%;
  position: relative;
  z-index: 1000;
  margin-top: 80px;
  margin-bottom: 166px;
}

.content .main {
  width: 380px;
  height: 480px;
  background-color: #fff;
  border-radius: 10px 10px;
  margin: 0px auto;
  position: absolute;
  left: 50%;
  margin-left: -190px;
  top: 50%;
  margin-top: -240px;
  box-shadow: 0px 0px 5px rgba(242, 243, 245, 0.6);
  overflow: hidden;
}
.content .main .box {
  width: 100%;
  height: 100%;
  position: relative;
}
.content .main .box .notice {
  width: 100%;
  height: 60px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  text-align: center;
  font-size: 16px;
  line-height: 60px;
  color: #000;
  box-shadow: 0px -2px 5px rgba(242, 243, 245, 0.6);
  background-color: #f9fafc;
}
.content .main .box .notice a {
  color: #379dff;
}
.content .main .login {
  padding: 80px 30px;
  padding-top: 37px;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.3)
}

.content .main .login .item {
  width: 100%;
  border: 1px solid #d9dde1;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 5px 5px;
  overflow: hidden;
}

.content .main .login .item.zhmm {
  text-align: right;
  font-size: 14px;
  line-height: 40px;
  color: #bababa;
  border: 0px;
  cursor: pointer;
}

.content .main .login .item input {
  height: 40px;
  border: 0px;
  width: 250px;
  float: left;
}

.content .main .login .item i.uname {
  width: 40px;
  height: 40px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/ico1.png");
  background-repeat: no-repeat;
  background-position: center center;
}

.content .main .login .item i.pwd {
  width: 40px;
  height: 40px;
  display: inline-table;
  float: left;
  background-image: url("~@/assets/images/ico2.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.content .main .login .btn {
  width: 100%;
  height: 43px;
  background-image: linear-gradient(
    to right,
    rgba(53, 145, 255, 1),
    rgba(63, 196, 254, 1)
  );
  border: 0px;
  border-radius: 21px 21px;
  font-size: 16px;
  color: #fff;
}

.content .main .login h3 {
  text-align: center;
  font-size: 20px;
  color: #38a0ff;
  margin-bottom: 40px;
}

.baofooter {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>